import * as yup from "yup";

export default yup.object().shape({
    email: yup
        .string()
        .trim()
        .email("Insira um endereço de e-mail válido")
        .required("Insira um endereço de e-mail"),
});
